import { render, staticRenderFns } from "./SuggestList.vue?vue&type=template&id=4140e960&"
import script from "./SuggestList.vue?vue&type=script&lang=ts&"
export * from "./SuggestList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports